import { Settings } from '@streamr/tv-engine';
import { isMobileDevice } from '../../utils/canvasResolution';
const OFF = new Set(['off', '0', 'false']);
const ON = new Set(['on', '1', 'true']);
export function resolveLowQualityStreamOptions(input) {
    if (input.isMobile)
        return { enabled: false, source: 'mobile' };
    const param = new URLSearchParams(input.search).get('lowQualityStream');
    if (param !== null && OFF.has(param))
        return { enabled: false, source: 'url' };
    if (param !== null && ON.has(param))
        return { enabled: true, source: 'url' };
    const stored = input.localStorageValue;
    if (stored !== null && OFF.has(stored)) {
        return { enabled: false, source: 'storage' };
    }
    if (stored !== null && ON.has(stored)) {
        return { enabled: true, source: 'storage' };
    }
    return { enabled: input.settingEnabled, source: 'setting' };
}
/** Browser entry point: page URL + localStorage + device class. */
export function readLowQualityStreamOptions() {
    let search = '';
    let localStorageValue = null;
    try {
        search = window.location.search;
        localStorageValue = window.localStorage.getItem('lowQualityStream');
    }
    catch {
        // no window / storage access: defaults
    }
    return resolveLowQualityStreamOptions({
        search,
        localStorageValue,
        isMobile: isMobileDevice(),
        settingEnabled: Settings.lowQualityStreamEnabled,
    });
}
